module.exports = __webpack_public_path__ + "img/Mongolia_Badges_01_Attraction_Genghis-Khan-Statue-Complex_a.4cb0314a.svg";